import { createSlice } from '@reduxjs/toolkit'

const downloadSlice = createSlice({
    name: 'download',
    initialState: {},
    reducers: {
        downloadTicketsAndVouchers() {},
        downloadTickets() {},
        downloadVouchers() {},
    },
})

const { actions, reducer } = downloadSlice

export const { downloadTickets, downloadVouchers, downloadTicketsAndVouchers } = actions

export default reducer
